import React from 'react';
import styleService from '@nykaa/deals-utils/styles';
import styled from '../../../theme';
import CONFIGURATIONS from '../constants';
const { getPaddingStyles, getMarginStyles, getFontStyles, setVisibility, } = styleService.utils;
export const MessageStyled = styled.div `
  color: green;
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  text-overflow: ellipsis;
  max-width: -webkit-fill-available;
  clear: both;
  visibility: ${({ isMessage }) => !isMessage && 'hidden'};
  overflow: hidden;
  white-space: nowrap;
  min-height: 18.5px;
  ${({ visible }) => setVisibility(visible)};
`;
const Message = ({ style, inStock, message }) => {
    const messageDisplay = inStock ? message : CONFIGURATIONS.OUT_OF_STOCK;
    return (React.createElement(MessageStyled, { visible: style === null || style === void 0 ? void 0 : style.visible, margin: style.margin, padding: style.padding, isMessage: !!messageDisplay, text: inStock ? style.positiveText : style.negativeText }, messageDisplay));
};
export default Message;
